/* eslint-disable no-debugger */
import { roleAccess } from '../constants'

const canUse = (route, currentRole) => {
  if (currentRole) {
    const index = roleAccess[currentRole].findIndex((item) => item.name === route.name)
    return index >= 0 ? { ...route, default: roleAccess[currentRole][index]?.default } : null
  }
  return null
}

export default (route, user = {}) => {
  const { roleId } = user?.role
  if (roleId !== undefined) {
    return route.name ? canUse(route, roleId.toString()) : route
  }
  return null
}
